module.exports = __webpack_public_path__ + "static/media/screen-en.b044ad96.png";